import config from '../config';
import { allUserTab, clusterOrPSPTab, cspTab, feTab, ispTab, iwanTab, scmTab, spTab, vpTab } from '../pages/team/TeamController';
import { partners, user } from '../types';
import { validateNumberValue } from '../utils/common';

const INITIAL_STATE = {
    error: undefined,
    partnersList: [],
    userFilterList: [],
    groupUserList: [],
    hasPartnerListReachedLast: false,
    teamUserList: [],
    hasUserListReachedLast: false,
    userPermissions: {},
    usersDropdownList: [],
    userList: undefined,
    userListMetaData: {},
    usersCount: {},
    partnerFilterPayload: {}
};

export const transformTab = (tab) => {
    return {
        ...tab,
        path: tab.label.toLowerCase().replace(/\s+/g, '_'),
        label: tab.label.replace(/\b\w+/g, word => word[0].toUpperCase() + word.slice(1).toLowerCase())
    }
}

const partnerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case partners.PARTNERS_LIST_SUCCESS:
            let partnersList = action.payload;
            partnersList = partnersList.sort((i, j) => j.worked_on_tickets_count - i.worked_on_tickets_count || j.status - i.status);
            return {
                ...state,
                partnersList,
            };

        case partners.PARTNERS_SERVICE_LOCATIONS_UPDATE: {
            const { userIds, details } = action.payload;
            const userId = userIds[0];
            const office_location = Array.isArray(details.operational_areas) && details.operational_areas.filter((area) => area.fk_user_id === userId);

            let updatedPartnersList = state.userList.map((partner) => {
                if (partner.id === userId) {
                    return { ...partner, office_location }
                } else return partner;
            });

            return {
                ...state,
                userList: updatedPartnersList,
            };
        }
        case partners.PARTNERS_LIST_DROPDOWN_SUCCESS:
            return {
                ...state,
                partnersListDropdown: action.payload,
            };
        case partners.CLEAR_PARTNERS_LIST_DROPDOWN:
            return {
                ...state,
                partnersListDropdown: undefined,
            };
        case partners.GROUP_USERS_LIST_SUCCESS:
            return {
                ...state,
                groupUsersOptions: action.payload,
            };
        case partners.CLEAR_PARTNERS_DROPDOWN:
            return {
                ...state,
                partnersListDropdown: [],
            };
        case partners.UPDATE_TOOLS_PARTNERS_IN_STORE: {
            const { spId, toolNames } = action.payload;
            const updatePartnerList = state.userList.map((partner) => {
                if (partner?.service_partner?.service_partner_id === spId) return { ...partner, service_partner_tools: toolNames };
                return partner;
            });

            return {
                ...state,
                userList: updatePartnerList,
            };
        }
        case partners.IWAN_DROPDOWN_SUCCESS: {
            return {
                ...state,
                iwanDropdown: action.payload,
            };
        }
        case partners.CLEAR_PARTNER_LIST_FROM_STORE: {
            return {
                ...state,
                partnersList: INITIAL_STATE.partnersList,
                userFilterList: INITIAL_STATE.userFilterList,
            };
        }

        case partners.GET_PARTNER_LIST_SUCCESS: {
            const userList = action.payload.data;
            const userListMetaData = action.payload.metadata;
            const openTab = action.payload.tab;
            return {
                ...state,
                userList,
                userListMetaData: { ...state.userListMetaData, [openTab]: userListMetaData }
            };
        }

        case user.GET_ADDITIONAL_DETAILS_SUCCESS: {
            const { regions, kyc, invitations, tickets } = action.payload;
            const userList = state.userList || [];
            const updatedUserList = userList.map((user) => {
                const userRegions = regions.filter((region) => region.user_id === user.id);
                const kyc_list = kyc.filter((kyc) => kyc.user_id === user.id);
                let by = invitations.find((inv) => inv.user_id === user.id) || { full_name: 'Self Onboarded' };
                const ticket_executed = tickets.find((tic) => tic.agent_id === user.id);
                if (!by.id) {
                    by.full_name = 'Self Onboarded';
                }
                return {
                    ...user, regions: userRegions, kyc_list, invited_by: by, ticket_executed
                };
            });

            return {
                ...state,
                userList: updatedUserList
            }
        }
        case partners.GET_PARTNER_FILTER_SUCCESS: {
            return {
                ...state,
                userFilterList: {
                    ...action.payload, status: [
                        {
                            value: 'active',
                            label: 'Active'
                        },
                        {
                            value: 'inactive',
                            label: 'Inactive'
                        },
                        {
                            value: 'disabled',
                            label: 'Disabled'
                        },
                        {
                            value: 'onboarding_pending',
                            label: 'Onboarding Pending'
                        },
                        {
                            value: 'verification_pending',
                            label: 'Verification Pending'
                        },
                        {
                            value: 'kyc_pending',
                            label: 'KYC Pending'
                        },
                    ]
                },
            };
        }

        case partners.GET_FILTERED_PARTNER_LIST_SUCCESS: {
            const { users, count, tab } = action.payload;
            const userList = transformUsers(users);
            return {
                ...state,
                userList,
                filteredUsersCount: { ...state.filteredUsersCount, [tab]: count },
            };
        }

        case partners.GET_PARTNER_DETAILS_LIST_SUCCESS: {
            const { operational_areas, tools, usecases, inventory, incentive_areas, engineers, asset_types, income_details, customer_details, addtional_details } = action.payload;
            let transformedList = state.userList;
            transformedList = transformedList.map((user) => {
                let office_location = [];
                let incentive_locations = [];
                let worked_on_asset_types = [];
                let service_partner_tools = [];
                let worked_on_use_cases = [];
                let user_inventory;
                let engineers_count;
                let income;
                let customer = {};
                let additionalData = {};

                if (Array.isArray(addtional_details) && addtional_details.length > 0) {
                    additionalData = addtional_details.find((u) => u.id === user.legacy_id);
                }

                if (Array.isArray(customer_details) && customer_details.length > 0) {
                    customer = customer_details.find((cust) => cust.fk_user_id === user.legacy_id);
                }
                if (Array.isArray(operational_areas) && operational_areas.length > 0) {
                    office_location = operational_areas.filter((area) => area.fk_user_id === user.legacy_id);
                }
                if (Array.isArray(incentive_areas) && incentive_areas.length > 0) {
                    incentive_locations = incentive_areas.filter((area) => area.fk_user_id === user.legacy_id);
                }
                if (Array.isArray(asset_types) && asset_types.length > 0) {
                    worked_on_asset_types = asset_types.filter((asset) => asset.fk_user_id === user.legacy_id).map((asset) => asset.title);
                }
                if (Array.isArray(tools) && tools.length > 0) {
                    service_partner_tools = tools.filter((tool) => tool.fk_user_id === user.legacy_id).map((tool) => tool.title);
                }
                if (Array.isArray(usecases) && usecases.length > 0) {
                    worked_on_use_cases = usecases.filter((usecase) => usecase.fk_user_id === user.legacy_id).map((usecase) => usecase.title);
                }
                if (Array.isArray(inventory) && inventory.length > 0) {
                    user_inventory = inventory.find((inv) => inv.fk_user_id === user.legacy_id)?.inventory;
                }
                if (Array.isArray(engineers) && engineers.length > 0) {
                    engineers_count = engineers.find((inv) => inv.fk_user_id === user.legacy_id)?.count;
                }
                if (Array.isArray(income_details) && income_details.length > 0) {
                    let findInc = income_details.find((inc) => inc.fk_user_id === user.legacy_id);
                    if (findInc) {
                        income = {
                            current_month_income: validateNumberValue(findInc.current_month_income), average_monthly_income: validateNumberValue(findInc.average_monthly_income), total_income: validateNumberValue(findInc.total_income),
                            wallet_balance: validateNumberValue(findInc.wallet_balance)
                        }
                    }
                }

                return { ...user, ...additionalData, office_location, worked_on_asset_types, service_partner_tools, worked_on_use_cases, inventory: user_inventory, engineers_count, incentive_areas: incentive_locations, income_details: income, customer_details: customer };
            });

            return {
                ...state,
                userList: transformedList
            };
        }
        case partners.REMOVE_PARTNER_LIST_FROM_STORE: {
            return {
                ...state,
                userList: undefined
            };
        }
        case partners.SET_TEAM_FILTER_DETAILS_IN_STORE: {
            const { payload, page, limit, query, roles, tags, status } = action.payload;
            return {
                ...state,
                rowsPerPage: limit,
                page,
                searchQuery: query,
                filterPayload: payload,
                roles,
                tags,
                status
            };
        }
        case partners.GET_PARTNER_COUNT_SUCCESS: {
            return {
                ...state,
                usersCount: action.payload,
            };
        }

        case partners.GET_SCM_CLUSTER_AND_PSP_LIST_SUCCESS: {
            return {
                ...state,
                partnersList: action.payload
            }
        }
        case partners.GET_SP_FE_LIST_SUCCESS: {
            return {
                ...state,
                partnersList: action.payload
            }
        }


        case partners.GET_GROUP_USER_LIST_SUCCESS: {
            const { data, append } = action.payload;
            let userList = [...data]
            if (append) {
                userList = [...state.groupUserList, ...data];
            }

            return {
                ...state,
                groupUserList: userList,
            };
        }
        case partners.GET_NEXT_GROUP_USER_LIST_SUCCESS: {
            const { data, append } = action.payload;
            let userList = [...data]
            if (append) {
                userList = [...state.groupUserList, ...data];
            }

            return {
                ...state,
                groupUserList: userList,
            };
        }
        case partners.GET_DEVELOPERS_LIST_SUCCESS: {
            return {
                ...state,
                groupUserList: action.payload
            }
        }
        case partners.CLEAR_GROUP_USER_FROM_STORE: {
            return {
                ...state,
                groupUserList: INITIAL_STATE.groupUserList
            }
        }
        case partners.GET_FILTERED_GROUP_USER_LIST_SUCCESS: {
            const { data, append } = action.payload;
            let userList = [...data]
            if (append) {
                userList = [...state.groupUserList, ...data];
            }

            return {
                ...state,
                groupUserList: userList,
            };
        }
        case partners.GET_AREA_COUNT_SUCCESS: {
            return {
                ...state,
                areaCountList: action.payload?.map(item => {
                    return { ...item, totalCount: ` ${item?.message ? item?.message : `${item?.ticketCount} / ${item.spoCount}`}` }
                })
            };
        }
        case partners.GENERATE_AFFILIATE_LINK_SUCCESS: {
            const { userId, affiliate_id, store_ref_code, store_affiliate_link } = action.payload;
            const userListAfterSucess = state.userList.map((user) => {
                if (user.id === userId) {
                    return { ...user, affiliate_id, store_ref_code, store_affiliate_link };
                }
                return user;
            });
            return { ...state, userList: userListAfterSucess };
        }

        case partners.GET_PARTNER_LIST_DROPDOWN_SUCCESS: {
            const { data, concat } = action.payload;
            const usersDropdownList = state.usersDropdownList || [];
            let newList = data;

            if (concat) {
                newList = [...usersDropdownList, ...newList]
            }

            return { ...state, usersDropdownList: newList, hasPartnerListReachedLast: data.length === 0 };
        }

        case partners.CLEAR_PARTNERS_DROPDOWN_LIST: {
            return { ...state, hasPartnerListReachedLast: false, usersDropdownList: undefined };
        }
        case user.UPDATE_PARTNER_PROFILE_SUCCESS: {
            const user = action.payload;
            const userList = state.userList.map((u) => {
                if (u.id === user.id) return { ...u, ...user };
                return u;
            })

            return { ...state, userList };
        }

        case user.UPDATE_USER_STATUS_PROFILE_SUCCESS: {
            const { updatedUser } = action.payload;
            const userList = state.userList.map((user) => {
                if (user.id === updatedUser.id) {
                    return { ...user, disabled_duration: updatedUser.disabled_duration, status: updatedUser.status };
                }
                return user;
            });
            return { ...state, userList };
        }

        case partners.UPDATE_USER_LIST_IN_STORE: {
            const { property, userId } = action.payload;
            const userList = state.userList.map((u) => {
                if (u.id === userId) return { ...u, [property]: ((u[property] || 0) + 1) % 2, };
                return u;
            })

            return { ...state, userList };
        }
        case partners.GET_TEAMS_ROLES_SUCCESS: {
            const rolesList = action.payload;
            const updatedRolesList = rolesList.map(transformTab);
            return { ...state, rolesList: updatedRolesList }
        };

        case partners.ROLES_INVITE_LIST_SUCCESS:
            return { ...state, inviteRoles: action.payload }

        case partners.CHECK_PERMISSION_SUCCESS: {
            const { permissions } = action.payload;
            const userPermissions = state.userPermissions;

            permissions.forEach(({ object, relation, allowed }) => {
                userPermissions[`${relation}_${object}`] = allowed
            })
            return { ...state, userPermissions }
        }

        case user.REMOVE_USER_TAGS_SUCCESS:
        case user.ADD_USER_TAGS_SUCCESS: {
            const { userId, user } = action.payload;
            const userList = state.userList.map((u) => {
                if (u.id === userId) return { ...u, tags: user.tags };
                return u;
            });

            return { ...state, userList }
        }
        case user.DISABLE_USER_SUCCESS: {
            const { user } = action.payload;
            const userList = state.userList.map((u) => {
                if (u.id === user.id) return user
                return u
            });
            return { ...state, userList }
        }
        case user.ENABLE_USER_SUCCESS: {
            const { user } = action.payload;
            const userList = state.userList.map((u) => {
                if (u.id === user.id) return user
                return u
            });

            return { ...state, userList }
        }
        case user.ADD_TERRITORIES_SUCCESS: {
            let { user_id, regions } = action.payload;
            const userList = state.userList.map((u) => {
                if (u.id === user_id) {
                    const existingRegions = u.regions || [];
                    const addedRegions = regions.map((region) => {
                        return {
                            region_id: region.id,
                            region_name: region.name,
                            region_type: region.type,
                            country_id: region.country_id,
                            has_worked_on: false
                        }
                    });
                    existingRegions.push(...addedRegions)
                    return { ...u, regions: existingRegions }
                }
                return u
            });

            return { ...state, userList }
        }

        case user.REMOVE_TERRITORIES_SUCCESS: {
            const { user_id, regionsIds } = action.payload;
            const userList = state.userList.map((u) => {
                if (u.id === user_id) {
                    let regions = u.regions || [];
                    regions = regions.filter((t) => !regionsIds.includes(t.region_id));
                    return { ...u, regions }
                }
                return u
            });

            return { ...state, userList }
        }
        case user.GET_USER_TERRITORIES_SUCCESS: {
            const territoriesList = action.payload;
            let userList = state.userList || [];
            userList = userList.map((u) => {
                let findTerritories = territoriesList.find(({ user }) => {
                    return user === u.id
                });

                if (findTerritories && findTerritories.regions) {
                    return {
                        ...u,
                        territories: findTerritories.regions
                    }
                }
                return u;
            })
            return { ...state, userList };
        }

        case user.UPDATE_USER_PROFILE_SUCCESS: {
            const { payload, updatedUser } = action.payload;
            const updatedLoggedUser = {};
            const updatedNewLoggedUser = {};

            Object.keys(updatedUser || {}).forEach(key => {
                if (updatedUser[key] !== undefined) {
                    updatedLoggedUser[key] = updatedUser[key];
                }
            });

            Object.keys(payload || {}).forEach(key => {
                if (payload[key] !== undefined) {
                    updatedNewLoggedUser[key] = payload[key];
                }
            });

            const userList = state.userList.map(user => {
                if (user.id === updatedUser.id) {
                    return { ...user, ...updatedUser };
                }
                return user;
            });

            return {
                ...state,
                userList
            }
        }

        case partners.SET_PARTNER_FILTER_PAYLOAD: {
            return {
                ...state,
                partnerFilterPayload: action.payload
            }
        }

        case user.REFRESH_LINKED_STATUS_SUCCESS: {
            const { userId, is_kyc_verified } = action.payload;
            const userList = state.userList.map((user) => {
                if (user.id === userId) return { ...user, is_kyc_verified };
                return user;
            });
            return { ...state, userList };
        }

        case partners.CHECK_PERMISSION_FAILURE:
        case partners.GET_FILTERED_GROUP_USER_LIST_FAILURE:
        case partners.GET_GROUP_USER_LIST_FAILURE:
        case partners.GET_NEXT_GROUP_USER_LIST_FAILURE:
        case partners.GET_DEVELOPERS_LIST_FAILURE:
        case partners.GET_SP_FE_LIST_FAILURE:
        case partners.GET_SCM_CLUSTER_AND_PSP_LIST_FAILURE:
        case partners.IWAN_DROPDOWN_FAILURE:
        case partners.GET_FILTERED_PARTNER_LIST_FAILURE:
        case partners.PARTNERS_LIST_FAILURE:
        case partners.PARTNERS_LIST_DROPDOWN_FAILURE:
        case partners.GET_AREA_COUNT_FAILURE:
        case partners.REMOVE_OR_GIVE_HELP_ACCESS_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return { ...state };
    }
};

export default partnerReducer;


const transformTeamCount = (count) => {
    let allCount = 0
    Object.entries(count).forEach(([key, value]) => {
        allCount += validateNumberValue(value);
    })
    return {
        [spTab.path]: count.vendor,
        [ispTab.path]: count.isp,
        [iwanTab.path]: count.iwan,
        [cspTab.path]: count.csp,
        [feTab.path]: count.engineer,
        [vpTab.path]: count.verification_pending,
        [scmTab.path]: count.scm,
        [clusterOrPSPTab.path]: validateNumberValue(count.psp) + validateNumberValue(count.supervisor) + validateNumberValue(count.cluster),
        [allUserTab.path]: allCount
    }
}

const transformUsers = (users) => {
    if (Array.isArray(users)) {
        return users.map((user) => {
            if (user.affiliate_id) {
                return { ...user, sp_id: validateNumberValue(user?.service_partner?.service_partner_id), worked_on_tickets_count: user.tickets_executed, store_affiliate_link: `${config.store_affiliate_link_static}${user.store_ref_code}` }
            }
            return { ...user, sp_id: validateNumberValue(user?.service_partner?.service_partner_id), worked_on_tickets_count: user.tickets_executed }
        }
        )
    }
    return [];
}